import { render, staticRenderFns } from "./my_profile.vue?vue&type=template&id=33b776e1"
import script from "./my_profile.vue?vue&type=script&lang=js"
export * from "./my_profile.vue?vue&type=script&lang=js"
import style0 from "./my_profile.vue?vue&type=style&index=0&id=33b776e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports